// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__1ihq5","image":"Banner_image__2Qdp4"};